import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();

  const footerLinks = {
    company: [
      { name: 'About Us', href: '#about' },
      { name: 'Our Services', href: '#services' },
      { name: 'Games Portfolio', href: '#games' },
      { name: 'Contact', href: '#contact' }
    ]
  };

  const handleFooterNavigation = (href) => {
    if (href.startsWith('#') && href !== '#') {
      const sectionId = href.substring(1);
      if (location.pathname === '/') {
        // If on homepage, scroll to section
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // If on other pages, navigate to homepage then scroll
        window.location.href = `/${href}`;
      }
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-logo">
              <h3>Ludic Labs Technology Limited</h3>
              <p>Creating engaging hyper-casual games for millions of players worldwide.</p>
            </div>

            <div className="footer-links">
              <div className="link-column">
                <h4>Company</h4>
                <ul>
                  {footerLinks.company.map((link, index) => (
                    <li key={index}>
                      <button onClick={() => handleFooterNavigation(link.href)}>
                        {link.name}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="footer-contact">
            <h4>Contact Information</h4>
            <div className="contact-info">
              <p>📧 support@ludiclabstech.com</p>
              <p>📍 RM A5,7/F, ASTORIA BUILDING, NO.34 ASHLEY ROAD, TSIM SHA TSUI HONG KONG</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Ludic Labs Technology Limited All rights reserved.</p>
            <div className="footer-meta">
              <span>Powered by React</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
